<template>
  <!-- 转盘 -->
  <div class="page-wrap" :style="{ backgroundImage : 'url(' + activeObj.pageBgc + ')'}">
    <div class="turntable-box">
      <div id="turntable-dom" :style="{ backgroundImage : 'url(' + activeObj.turntableBgc + ')'}"></div>
      <img :src="activeObj.turntablebtn" alt="" @click="startPlay" class="turntable-start-btn">
    </div>
    <div class=""></div>
  </div>
</template>

<script>
import { getTurntableConfig } from "@/api/luckDraw";
import { getLocal } from "@/utils/store";
export default {
  name: "turntable",
  data() {
    return {
      activeObj: {
        pageBgc: "/images/turntable-page-bg.png",
        turntablebtn: "/images/turntable-btn.png",
        turntableBgc: "/images/turntable-bg.png",
        prizeData: [
          {
            id: 1,
            prize: "88元",
          },
          {
            id: 2,
            prize: "20元",
          },
          {
            id: 3,
            prize: "100金币",
          },
          {
            id: 4,
            prize: "20元",
          },
          {
            id: 5,
            prize: "谢谢参与",
          },
          {
            id: 6,
            prize: "20元",
          },
          {
            id: 7,
            prize: "200元",
          },
          {
            id: 8,
            prize: "谢谢参与",
          },
        ],
      },
      pIndex: 0, // 中奖物品的下标
      rotNum: 0, // 旋转圈数基数
      time: 5000, // 旋转时间
      timer: null, // 定时器
      oTurntable: "", // 旋转圆盘背景图
      type: 0, // 0 图片 1 汉字
    };
  },
  created() {
    this.getInfo();
    this.activeObj.prizeData = this.autoRotate(this.activeObj.prizeData);
  },
  mounted() {
    // 设置过渡过属性用时5s
    this.oTurntable = document.querySelector("#turntable-dom");
    this.oTurntable.style.webkitTransition =
      "transform " + this.time / 1000 + "s ease";
  },
  methods: {
    //自动生成角度添加到数组上
    autoRotate(arr) {
      if (arr.length) {
        let len = arr.length;
        let base = 360 / len;
        arr.forEach((item, index) => {
          // 指的是某个奖品区域的中间 : base/2
          // item.angle = 360 - (base / 2 + index * base);
          item.angle = 360 - index * base;
        });
      }
      return arr;
    },

    // 点击开始,请求接口抽奖
    async startPlay() {
      const a = {
        prize: "200金币",
        id: 1,
      };
      this.startBtn(a);
    },

    // 开始转动,通过奖项级别进行匹配:id
    async startBtn(val) {
      const self = this;
      self.activeObj.prizeData.forEach((i, d) => {
        if (i.id == val.id) {
          self.pIndex = d;
        }
      });
      // 拿到相应的角度调旋转接口
      self.startrotate(self.activeObj.prizeData[self.pIndex].angle, () => {
        self.fulfillHandle(self.activeObj.prizeData[self.pIndex].prize);
      });
    },

    //开始旋转 angle角度  complete回调成功函数
    startrotate(angle, complete) {
      // 相应的角度 + 满圈 只是在原角度多转了几圈 360 * 6
      let rotate = 2160 * (this.rotNum + 1) + angle;
      this.oTurntable.style.webkitTransform = "rotate(" + rotate + "deg)";
      clearTimeout(this.timer);
      // 设置5秒后停止旋转,处理接口返回的数据
      this.timer = setTimeout(() => {
        complete();
        this.rotNum++;
      }, this.time);
    },

    //得奖后的处理
    fulfillHandle(prizeName) {
      this.$toast(prizeName);
    },

    //获取当前用户的抽奖信息
    getInfo() {
      this.$toast(getLocal({name:'token'}));
      getTurntableConfig()
        .then((res) => {
        })
        .catch((err) => {
          console.log(err)
          // this.$toast(err.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  height: 100%;
  box-sizing: border-box;
  padding-top: 165px;
  background-color: #6489cc;
  background-size: 100% auto;
  background-repeat: no-repeat;
  .turntable-box {
    width: 276px;
    height: 276px;
    position: relative;
    margin: 0px auto;
    overflow: hidden;
    #turntable-dom {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 1;
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
    .turntable-start-btn {
      position: absolute;
      width: 60px;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-59%);
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% auto;
      z-index: 3;
    }
  }
}
</style>